// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3VEr2","search":"Settings_search__342vq","filter":"Settings_filter__111Aa"};